import React from 'react';
import { Helmet } from 'react-helmet';

import { htmlToText, IsStringEmpty } from '../../utilities/CommonMethods';
import edyodaShare from '../../assets/edyoda_transparent_logo.png';

const addMetaTags = (props) => {
    // Log('HELMET PROPS => ', props);

    const DEFAULT_TITLE = "EdYoda Digital University";
    const DEFAULT_DESC = 'Visit us to join the growing community of 200,000+ learners, learning job-relevant skills. You can enroll to the job profile based online programs and get one step closer to your dream job. Start your learning journey today!';
    const DEFAULT_URL = "https://classroom.edyoda.com";
    // const DEFAULT_KEYWORDS = "python programming tutorial for beginners,machine learning online course,amazon web services tutorial for beginners,programming languages online course,free online courses, ISA, Income Share Agreement, India";

    return (
        IsStringEmpty(props.title) ?

            <Helmet
                title={DEFAULT_TITLE}
                meta={[
                    { name: "description", content: DEFAULT_DESC },
                    // { name: "keywords", content: "python programming tutorial for beginners,machine learning online course,amazon web services tutorial for beginners,programming languages online course,free online courses, ISA, Income Share Agreement, India" },

                    { property: "og:url", content: !IsStringEmpty(props.url) ? `https://classroom.edyoda.com${props.url}` : `${DEFAULT_URL}` },
                    { property: "og:title", content: `${DEFAULT_TITLE}` },
                    { property: "og:type", content: "website" },
                    { property: "og:description", content: `${DEFAULT_DESC}` },
                    { property: "og:image", content: `${edyodaShare}` },
                    { property: "og:locale", content: "en_US" },
                    { property: "og:site_name", content: "EdYoda Digital University" },

                    // {/* <!--twitter card -->  */}
                    { name: "twitter:title", content: `${DEFAULT_TITLE}` },
                    { name: "twitter:card", content: "summary" },
                    { name: "twitter:site", content: "@edyoda" },
                    { name: "twitter:image:src", content: `${edyodaShare}` },
                    { name: "twitter:description", content: `${DEFAULT_DESC}` },

                    { property: "fb:app_id", content: "281436786102094" },
                    { name: "prerender-status-code", content: props.error404 ? "404" : "200" }
                ]}
                link={[
                    { rel: "canonical", href: 'https://classroom.edyoda.com' }
                ]}
            />
            :
            <Helmet
                title={!IsStringEmpty(props.title) ? `${props.title.substr(0, 70)}` : `${DEFAULT_TITLE}`}
                meta={[
                    { name: "description", content: !IsStringEmpty(props.description) ? `${htmlToText(props.description)}` : `${DEFAULT_DESC}` },
                    // { name: "keywords", content: !IsStringEmpty(props.keywords) ? `${props.keywords}` : `${DEFAULT_KEYWORDS}` },
                    { property: "og:url", content: !IsStringEmpty(props.url) ? `https://classroom.edyoda.com${props.url}` : `${DEFAULT_URL}` },
                    { property: "og:title", content: !IsStringEmpty(props.title) ? `${props.title.substr(0, 70)}` : `${DEFAULT_TITLE}` },
                    { property: "og:type", content: "website" },
                    { property: "og:description", content: !IsStringEmpty(props.description) ? `${htmlToText(props.description).substr(0, 250)}` : `${DEFAULT_DESC}` },
                    { property: "og:image", content: !IsStringEmpty(props.thumbnail) ? `${props.thumbnail}` : `${edyodaShare}` },
                    { property: "og:locale", content: "en_US" },
                    { property: "og:site_name", content: "EdYoda Digital University" },

                    // {/* Twitter Meta Tags */},
                    { name: "twitter:title", content: !IsStringEmpty(props.title) ? `${props.title.substr(0, 70)}` : `${DEFAULT_TITLE}` },
                    { name: "twitter:description", content: !IsStringEmpty(props.description) ? `${htmlToText(props.description).substr(0, 250)}` : `${DEFAULT_DESC}` },
                    { name: "twitter:card", content: "summary" },
                    { name: "twitter:site", content: "@edyoda" },
                    { name: "twitter:image:src", content: !IsStringEmpty(props.thumbnail) ? `${props.thumbnail}` : `${edyodaShare}` },

                    { property: "fb:app_id", content: "281436786102094" }
                ]}
                link={[
                    { rel: "canonical", href: !IsStringEmpty(props.url) ? `https://classroom.edyoda.com${props.url.endsWith('/') ? props.url : props.url + '/'}` : '' }
                ]}
            />
    )
}

export default addMetaTags;